import * as React from 'react';
import moment from 'moment';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { Component } from 'react';
import { AppUser } from 'Src/views/App/App';
import { getParentInboxMessages, getParentInboxMessagesCount, getParentArchiveMessages } from 'Src/helpers/service/parent/messagesTable';
import { Loader } from 'Src/components/Loader/Loader';
import { ConsentRequestCard } from 'Src/components/ConsentRequestCard/ConsentRequestCard';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { MessageField } from 'Src/models/message';
import { FormSubmission } from 'Src/types/formSchema';
import { Map } from 'Src/components/Map/Map';
import { ParentalConsentRequestForm } from './ParentalConsentRequestForm/ParentalConsentRequestForm';
import {
  acceptParentConsentRequest,
  rejectParentConsentRequest,
  updateParentConsentRequest
} from 'Src/helpers/service/parent/messagesTable';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { getChildren } from '../../../../../helpers/service/parent/children';
import { EventInvitationMessage } from 'Src/models/message';
import { SchoolEvent } from 'Src/models/event';
import { Child } from 'Src/models/child';
import { INVITE_TYPE } from 'Src/consts/invite';
import { ItemsBar } from 'Src/views/GenericView/ParentView/Calendar/ItemsBar';
import { CARD_LIMIT } from 'Src/consts/table';
import { ParentFilterBar } from 'Src/components/ParentFilterBar/ParentFilterBar';
import { AppliedTextFilterChip } from 'Src/components/AppliedTextFilterChip/AppliedTextFilterChip';
import { getParentConsentEventName, hydrateParentConsentEvents } from '../getParentConsentEventName';
import { ConsentRequestDetails } from '../ConsentRequestDetails/ConsentRequestDetails';
import { ParentConsentEventList } from '../ParentConsentEventList';
import './ConsentRequestsInbox.scss';
import { ParentPageHeader } from '../../components/ParentPageHeader';
import '../../components/ParentLists.scss';

const FILTER_FIELDS_ALL: ColumnDefinition[] = [
  { text: 'Children', field: 'childIdList', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false },
  { text: 'Sport', field: 'sport', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Start date', field: 'startTime', type: FILTER_TYPE.DATE_INTERVAL, accessor: [''], isSort: true },
  { text: 'Deadline', field: 'deadlineForAnswers', type: FILTER_TYPE.NONE, accessor: [''], isSort: true }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  setNeedUpdate: () => void;
}

interface State {
  items: {
    consentRequest: EventInvitationMessage;
    childEvent: SchoolEvent;
  }[];
  selectedItem: {
    consentRequest: EventInvitationMessage;
    childEvent: SchoolEvent;
  };
  total: number;
  currentPage: number;
  filters: any;
  sortFieldName: string;
  sortDirection: string;
  isFiltersOpen: boolean;
  isLoading: boolean;
  isSchoolEventLoading: boolean;
  children: Child[];
  basePath: string;
  isRejectModalOpen: boolean;
  isAcceptModalOpen: boolean;
  isViewMapModalOpen: boolean;
  isDetailsModalOpen: boolean;
  isEditModalOpen: boolean;
  declineReason: string;
}

export class ConsentRequestsInbox extends Component<Props, State> {
  private answeredMessageIds = new Set<string>();
  private loadRequestId = 0;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      selectedItem: undefined,
      total: 0,
      currentPage: FIRST_PAGE,
      filters: {},
      sortFieldName: '',
      sortDirection: '',
      isFiltersOpen: false,
      isLoading: false,
      isSchoolEventLoading: false,
      basePath: '',
      children: [],
      isRejectModalOpen: false,
      isAcceptModalOpen: false,
      isViewMapModalOpen: false,
      isDetailsModalOpen: false,
      isEditModalOpen: false,
      declineReason: ''
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  private normalizeFiltersForQuery = (f: any) => {
    const out = { ...(f || {}) };

    const sportIdIn = propz.get(out, ['sportId', '$in']);
    if (typeof sportIdIn === 'string') out.sport = sportIdIn;
    else if (Array.isArray(sportIdIn) && sportIdIn.length) out.sport = sportIdIn[0];
    else if (typeof out.sportId === 'string') out.sport = out.sportId;
    delete out.sportId;

    const toIso = (s?: string) => {
      if (!s) return s;
      const m = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      return m ? `${m[3]}-${m[2]}-${m[1]}` : s;
    };

    if (typeof out.startTime === 'string' || typeof out.finishTime === 'string') {
      out.startTime = { from: toIso(out.startTime), to: toIso(out.finishTime) };
      delete out.finishTime;
    } else if (out.startTime && (out.startTime.from || out.startTime.to)) {
      out.startTime = { from: toIso(out.startTime.from), to: toIso(out.startTime.to) };
    }

    return out;
  };

  setItems() {
    const requestId = ++this.loadRequestId;
    const { history, user } = this.props;
    const search = parse(history.location.search);

    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortFieldName = '';
    if (typeof search.order === 'string') {
      [sortFieldName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortFieldName !== '';
    const sortDirectionExist = sortDirection !== '';

    const rawFilters = getFilters2(FILTER_FIELDS_ALL, search);

    const filtersForQuery = this.normalizeFiltersForQuery(rawFilters);

    const { sport, startTime, ...rest } = filtersForQuery;

    const where = {
      kind: 'EventInvitationMessage',
      ...getServerFieldSectionWhere(rest),
      ...(sport ? { sport } : {}),
      ...(startTime && (startTime.from || startTime.to) ? { startTime } : {})
    };

    const order = sortByFieldExist && sortDirectionExist ? `${sortFieldName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order, CARD_LIMIT);

    const countWhere = { ...where };
    delete countWhere.childIdList;

    const getItemsPromise = getParentInboxMessages(user, serverQueryFilter);
    const getAnsweredPromise = getParentArchiveMessages(user, { where, skip: 0, limit: 200, order });
    const getItemsCountPromise = getParentInboxMessagesCount(user, countWhere, true);
    const getChildrenPromise = getChildren(user);

    return BPromise.all([getItemsPromise, getItemsCountPromise, getChildrenPromise, getAnsweredPromise])
      .then(([consentRequests, consentRequestsCount, children, answeredRequests]) => {
        if (requestId !== this.loadRequestId) return;
        const visibleConsentRequests = consentRequests.filter(
          consentRequest => !this.answeredMessageIds.has(String(consentRequest.id))
        );
        const hiddenAnsweredCount = consentRequests.length - visibleConsentRequests.length;
        const upcomingAnswered = (answeredRequests || []).filter(message => moment(propz.get(message, ['eventData', 'startTime'])).isAfter(moment()));
        const combinedRequests = [...visibleConsentRequests, ...upcomingAnswered].filter((message, index, all) => all.findIndex(candidate => String(candidate.id) === String(message.id)) === index);
        const updatedItems = combinedRequests.map((consentRequest: EventInvitationMessage) => ({
          consentRequest,
          childEvent: propz.get(consentRequest, ['eventData'], {}) as SchoolEvent
        }));

        const hasChildSelection = Array.isArray(filtersForQuery.childIdList) && filtersForQuery.childIdList.length > 0;
        const itemCounts = consentRequestsCount.itemCounts || {};
        const matchingTotal = hasChildSelection && consentRequestsCount.itemCounts
          ? filtersForQuery.childIdList.reduce((sum, childId) => sum + (itemCounts[String(childId)] || 0), 0)
          : Number(consentRequestsCount.count);
        const effectiveTotal = Math.max(0, matchingTotal - hiddenAnsweredCount);
        const lastPage = Math.max(FIRST_PAGE, Math.ceil(effectiveTotal / CARD_LIMIT));
        if (page > lastPage) {
          const parts: string[] = [];
          if (lastPage !== FIRST_PAGE) parts.push(`page=${lastPage}`);
          if (isSortExist(sortDirection, sortFieldName)) {
            parts.push(getSearchOrder(sortDirection, sortFieldName));
          }
          if (isFilterExist2(filtersForQuery)) parts.push(getSearchFilter(filtersForQuery));
          history.replace({ pathname: history.location.pathname, search: parts.join('&') });
          return;
        }
        const childrenWithCounts = (children || []).map(child => ({
          ...child,
          itemCount: itemCounts[String(child.id)] || 0
        }));
        const filtersWithChild = hasChildSelection
          ? filtersForQuery
          : { ...filtersForQuery, childIdList: children.map(c => c.id) };

        this.setState({
          items: updatedItems,
          currentPage: page,
          children: childrenWithCounts,
          filters: filtersWithChild,
          sortDirection,
          sortFieldName,
          total: effectiveTotal,
          basePath: history.location.pathname,
          isLoading: false
        });
        hydrateParentConsentEvents(user, updatedItems).then(items => {
          if (requestId === this.loadRequestId) this.setState({ items });
        });
      })
      .catch(() => {
        if (requestId === this.loadRequestId) this.setState({ isLoading: false });
      });
  }

  setCurrentPageParams = (currentPage: number): void => {
    const { history } = this.props;
    let search: string[] = [];

    const { filters, sortFieldName, sortDirection, basePath } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortFieldName)) {
      search.push(getSearchOrder(sortDirection, sortFieldName));
    }

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) {
      search.push(getSearchFilter(filtersForUrl));
    }

    history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortFieldName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortFieldName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) {
      search.push(getSearchFilter(filtersForUrl));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters } = this.state;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = FILTER_FIELDS_ALL.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { sortDirection, sortFieldName } = this.state;
    const parts: string[] = [];

    if (isSortExist(sortDirection, sortFieldName)) {
      parts.push(getSearchOrder(sortDirection, sortFieldName));
    }

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) {
      parts.push(getSearchFilter(filtersForUrl));
    }

    this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
  };

  onClearFilterClick = (): void => {
    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onRejectConsentRequestClick = () => {
    const { user, setNeedUpdate } = this.props;
    const { selectedItem } = this.state;

    const id = propz.get(selectedItem, ['consentRequest', 'id'], '');

    this.setState({
      isLoading: true
    });

    rejectParentConsentRequest(user, id, this.state.declineReason)
      .then(() => {
        this.answeredMessageIds.add(String(id));
        this.setState({
          isRejectModalOpen: false,
          selectedItem: undefined
        });

        return this.setItems();
      })
      .then(() => {
        setNeedUpdate();
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  onAcceptConsentRequestClick = (fields: MessageField[], submission?: FormSubmission) => {
    const { user, setNeedUpdate } = this.props;
    const { selectedItem } = this.state;

    const id = propz.get(selectedItem, ['consentRequest', 'id'], '');

    this.setState({
      isLoading: true
    });

    const data = { fields, ...(submission || {}) };

    acceptParentConsentRequest(user, id, data)
      .then(() => {
        this.answeredMessageIds.add(String(id));
        this.setState({
          isAcceptModalOpen: false,
          selectedItem: undefined
        });
        return this.setItems();
      })
      .then(() => {
        setNeedUpdate();
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  };

  renderAcceptConsentRequestModal = () => {
    const { user } = this.props;
    const { isAcceptModalOpen, selectedItem } = this.state;
    if (!selectedItem) return null;

    const { consentRequest, childEvent } = selectedItem;

    const first = propz.get(consentRequest, ['playerDetailsData', 'firstName'], '');
    const last = propz.get(consentRequest, ['playerDetailsData', 'lastName'], '');
    const studentName = `${first} ${last}`.trim();

    const startTime = propz.get(childEvent, ['startTime']);
    const endTime = propz.get(childEvent, ['endTime']);
    const sameDay = startTime && endTime && moment(startTime).isSame(endTime, 'day');

    const dateText = startTime
      ? sameDay
        ? `${moment(startTime).format('ddd D MMM YYYY')} • ${moment(startTime).format('HH:mm')}–${moment(
            endTime
          ).format('HH:mm')}`
        : `${moment(startTime).format('ddd D MMM YYYY')} – ${moment(endTime).format('ddd D MMM YYYY')}`
      : '';

    const placeName = propz.get(childEvent, ['venue', 'placeData', 'name'], '');
    const postcode = propz.get(childEvent, ['venue', 'postcodeData', 'postcode'], '');
    const venue = placeName || postcode || '';

    const requestChildId = String(
      propz.get(consentRequest, ['playerDetails', 'userId'], '') ||
        propz.get(consentRequest, ['playerDetailsData', 'id'], '')
    );
    const childIdList = requestChildId ? [requestChildId] : this.state.children.map(c => c.id);
    const fullEventName = getParentConsentEventName(childEvent, childIdList, consentRequest);

    return (
      <SimpleModal
        isOpen={isAcceptModalOpen}
        onCloseClick={this.closeAcceptConsentRequestModal}
        showFooter={false}
        customClass="AcceptModal"
        title="Consent request"
        dialogStyle={{ maxWidth: 720 }}
        guardUnsavedChanges
        unsavedChangesMessage="You have unsaved consent answers. If you close now, those changes will be lost."
      >
        <div className="parentConsentDrawer__context"><span>CONSENT REQUEST</span><strong>{studentName}</strong><small>{fullEventName}{dateText ? ` · ${dateText}` : ''}</small>{consentRequest.deadlineForAnswers ? <em>Reply by {moment(consentRequest.deadlineForAnswers).format('D MMM, HH:mm')}</em> : null}</div>

        <ParentalConsentRequestForm
          user={user}
          message={consentRequest}
          onCloseClick={this.closeAcceptConsentRequestModal}
          onAcceptClick={this.onAcceptConsentRequestClick}
          onDeclineClick={() => this.setState({ isAcceptModalOpen: false, isRejectModalOpen: true })}
        />
      </SimpleModal>
    );
  };

  openAcceptConsentRequestModal = message => {
    this.setState({
      isAcceptModalOpen: true,
      isDetailsModalOpen: false,
      selectedItem: message
    });
  };

  closeAcceptConsentRequestModal = () => {
    this.setState({
      isAcceptModalOpen: false,
      selectedItem: undefined
    });
  };

  renderRejectConsentRequestModal = () => {
    const { isRejectModalOpen, selectedItem } = this.state;
    if (!selectedItem) return null;

    const { consentRequest, childEvent } = selectedItem;

    const first = propz.get(consentRequest, ['playerDetailsData', 'firstName'], '');
    const last = propz.get(consentRequest, ['playerDetailsData', 'lastName'], '');
    const studentName = `${first} ${last}`.trim();

    const startTime = propz.get(childEvent, ['startTime']);
    const endTime = propz.get(childEvent, ['endTime']);
    const sameDay = startTime && endTime && moment(startTime).isSame(endTime, 'day');

    const dateText = startTime
      ? sameDay
        ? `${moment(startTime).format('ddd D MMM YYYY')} • ${moment(startTime).format('HH:mm')}–${moment(
            endTime
          ).format('HH:mm')}`
        : `${moment(startTime).format('ddd D MMM YYYY')} – ${moment(endTime).format('ddd D MMM YYYY')}`
      : '';

    const placeName = propz.get(childEvent, ['venue', 'placeData', 'name'], '');
    const postcode = propz.get(childEvent, ['venue', 'postcodeData', 'postcode'], '');
    const venue = placeName || postcode || '';

    const requestChildId = String(
      propz.get(consentRequest, ['playerDetails', 'userId'], '') ||
        propz.get(consentRequest, ['playerDetailsData', 'id'], '')
    );
    const childIdList = requestChildId ? [requestChildId] : this.state.children.map(c => c.id);
    const fullEventName = getParentConsentEventName(childEvent, childIdList, consentRequest);

    return (
      <SimpleModal
        isOpen={isRejectModalOpen}
        onCloseClick={this.closeRejectConsentRequestModal}
        showFooter={false}
        customClass="DeclineModal"
        dialogStyle={{ maxWidth: 560 }}
        title="Confirm decline"
      >
        <div className="DeclineModal__header">
          <div className="DeclineModal__icon" aria-hidden>
            ⚠️
          </div>
          <div className="DeclineModal__titles">
            <h3>Decline this consent request?</h3>
            <p>
              If you decline, the school will be notified that <strong>{studentName}</strong> isn’t able to take part.
            </p>
          </div>
        </div>

        <div className="DeclineModal__summary">
          <div className="DeclineModal__row">
            <span className="label">Event</span>
            <span className="value">{fullEventName}</span>
          </div>
          {dateText && (
            <div className="DeclineModal__row">
              <span className="label">When</span>
              <span className="value">{dateText}</span>
            </div>
          )}
          {venue && (
            <div className="DeclineModal__row">
              <span className="label">Where</span>
              <span className="value">{venue}</span>
            </div>
          )}
        </div>

        <label className="DeclineModal__reason"><span>Reason <small>Optional · shared with the school</small></span><textarea maxLength={2000} value={this.state.declineReason} placeholder="For example: family commitment that day" onChange={event => this.setState({ declineReason: event.target.value })}/></label>
        <div className="DeclineModal__cta">
          <button className="btn btn-light" onClick={this.closeRejectConsentRequestModal}>
            Go back
          </button>
          <button className="btn btn-respond btn-decline" onClick={this.onRejectConsentRequestClick}>
            Decline request
          </button>
        </div>
      </SimpleModal>
    );
  };

  openRejectConsentRequestModal = message => {
    this.setState({
      isRejectModalOpen: true,
      isDetailsModalOpen: false,
      selectedItem: message,
      declineReason: ''
    });
  };

  closeRejectConsentRequestModal = () => {
    this.setState({
      isRejectModalOpen: false,
      selectedItem: undefined,
      declineReason: ''
    });
  };

  renderViewMapModal = () => {
    const { isViewMapModalOpen, selectedItem } = this.state;

    const point = propz.get(selectedItem, ['childEvent', 'venue', 'point']);

    return (
      <SimpleModal
        isOpen={isViewMapModalOpen}
        onCloseClick={this.closeViewMapModal}
        title="View map"
        customClass="modal-xl"
      >
        <Map point={point} customStylingClass="eChildEventVenueMap" isMarkerDraggable={false} />
      </SimpleModal>
    );
  };

  openViewMapModal = message => {
    this.setState({
      isViewMapModalOpen: true,
      selectedItem: message
    });
  };

  closeViewMapModal = () => {
    this.setState({
      isViewMapModalOpen: false,
      selectedItem: undefined
    });
  };

  openDetailsModal = message => {
    this.setState({ isDetailsModalOpen: true, selectedItem: message });
  };

  closeDetailsModal = () => {
    this.setState({ isDetailsModalOpen: false, selectedItem: undefined });
  };

  renderDetailsModal = () => {
    const { isDetailsModalOpen, selectedItem } = this.state;
    const status = String(propz.get(selectedItem, ['consentRequest', 'invitationStatus'], '')).toUpperCase();
    const accepted = status === 'ACCEPTED';
    return (
      <SimpleModal
        isOpen={isDetailsModalOpen}
        onCloseClick={this.closeDetailsModal}
        showFooter={false}
        title="Consent request details"
        side="right"
        customClass="parentConsentDrawer"
        dialogStyle={{ maxWidth: 560 }}
      >
        <ConsentRequestDetails message={selectedItem} childIdList={this.state.children.map(child => child.id)} />
        {selectedItem ? (
          <div className="parentConsentDrawer__actions">
            {accepted ? (
              <>
                <button type="button" className="is-danger" onClick={() => this.openRejectConsentRequestModal(selectedItem)}>
                  Withdraw consent
                </button>
                <button type="button" onClick={() => this.openEditModal(selectedItem)}>Edit answers</button>
              </>
            ) : (
              <button type="button" onClick={() => this.openAcceptConsentRequestModal(selectedItem)}>
                Give consent instead
              </button>
            )}
          </div>
        ) : null}
      </SimpleModal>
    );
  };

  openEditModal = message => {
    this.setState({ isEditModalOpen: true, isDetailsModalOpen: false, selectedItem: message });
  };

  closeEditModal = () => {
    this.setState({ isEditModalOpen: false, selectedItem: undefined });
  };

  onUpdateConsentRequestClick = (fields: MessageField[], submission?: FormSubmission) => {
    const id = propz.get(this.state.selectedItem, ['consentRequest', 'id'], '');
    this.setState({ isLoading: true });
    updateParentConsentRequest(this.props.user, id, { fields, ...(submission || {}) })
      .then(() => this.setItems())
      .then(() => {
        this.setState({ isEditModalOpen: false, selectedItem: undefined, isLoading: false });
        this.props.setNeedUpdate();
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  renderEditModal = () => {
    const { isEditModalOpen, selectedItem } = this.state;
    if (!isEditModalOpen || !selectedItem) return null;
    return (
      <SimpleModal
        isOpen={isEditModalOpen}
        onCloseClick={this.closeEditModal}
        showFooter={false}
        customClass="AcceptModal"
        title="Edit answers"
        dialogStyle={{ maxWidth: 720 }}
        guardUnsavedChanges
        unsavedChangesMessage="You have unsaved consent answers. If you close now, those changes will be lost."
      >
        <ParentalConsentRequestForm
          user={this.props.user}
          message={selectedItem.consentRequest}
          onCloseClick={this.closeEditModal}
          onAcceptClick={this.onUpdateConsentRequestClick}
          submitLabel="Save changes"
        />
      </SimpleModal>
    );
  };

  onChildPickerClick = (childId: string): void => {
    const { children, sortDirection, sortFieldName } = this.state;

    const nextFilters = {
      ...this.state.filters,
      childIdList: childId === 'all' ? children.map(c => c.id) : [childId]
    };

    this.setState({ filters: nextFilters }, () => {
      const parts: string[] = [];
      if (isSortExist(sortDirection, sortFieldName)) {
        parts.push(getSearchOrder(sortDirection, sortFieldName));
      }
      const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
      if (isFilterExist2(filtersForUrl)) {
        parts.push(getSearchFilter(filtersForUrl));
      }
      this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
    });
  };

  render() {
    const { user } = this.props;
    const { isLoading, isFiltersOpen, total, currentPage, items, filters, children } = this.state;

    const childIdList = children.map(child => child.id);

    if (isLoading) {
      return <Loader />;
    }

    const selectedChildIds =
      filters.childIdList && filters.childIdList.length ? filters.childIdList : children.map(c => c.id);
    return (
      <main className="parentPage parentListPage parentConsentPage">
        {this.renderAcceptConsentRequestModal()}
        {this.renderRejectConsentRequestModal()}
        {this.renderViewMapModal()}
        {this.renderDetailsModal()}
        {this.renderEditModal()}

        <ParentPageHeader
          title="Consent requests"
          subtitle="Give or decline permission for your children to take part in school events."
          tabs={[
            {
              label: 'Upcoming',
              active: true,
              count: total,
              onClick: () => this.props.history.push('/consentRequests/inbox')
            },
            { label: 'Past this year', onClick: () => this.props.history.push('/consentRequests/history') },
            { label: 'Previous years', onClick: () => this.props.history.push('/consentRequests/archive') }
          ]}
        />

        <ItemsBar
          items={children}
          itemIdList={selectedChildIds}
          onClick={this.onChildPickerClick}
          allItemsTitle="All children"
          getItemName={(c: any) => `${c.firstName} ${c.lastName}`}
        />

        {total > CARD_LIMIT ? <div className="parentListControls">
          <Pagination2
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
            limit={CARD_LIMIT}
            modern
          />
        </div> : null}

        <AppliedTextFilterChip
          history={this.props.history}
          location={this.props.location}
          filters={[
            { filterKey: 'sport', label: 'Activity/Sport' },
            { filterKey: 'startTime', label: 'Start date', type: 'date' }
          ]}
        />

        {isFiltersOpen && (
          <div className="parentFilterSurface">
            <ParentFilterBar
              filters={this.state.filters}
              onTableFilterChange={this.onTableFilterChange}
              onApply={this.onApplyFilterClick}
              onClear={this.onClearFilterClick}
              onCancel={() => this.setState({ isFiltersOpen: false })}
              labels={{ text: 'Activity/Sport', date: 'Event date' }}
              fieldKeys={{ textKey: 'sport', dateKey: 'startTime' }}
            />
          </div>
        )}

        {items.length === 0 ? (
          <div className="parentListEmpty">
            <strong>No consent requests</strong>
            <span>There are no requests matching the selected children and filters.</span>
          </div>
        ) : (
          <ParentConsentEventList
            items={items}
            childIdList={childIdList}
            onRespond={this.openAcceptConsentRequestModal}
            onView={this.openDetailsModal}
            onEdit={this.openEditModal}
            onWithdraw={this.openRejectConsentRequestModal}
            onGiveConsentInstead={this.openAcceptConsentRequestModal}
          />
        )}
      </main>
    );
  }
}
